export const ESTADOS_MEXICO = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila de Zaragoza",
  "Colima",
  "Durango",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "México",
  "Michoacán de Ocampo",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz de Ignacio de la Llave",
  "Yucatán",
  "Zacatecas",
];

export const STATE_SHORT = {
  "Ciudad de México": "CDMX",
  "Coahuila de Zaragoza": "Coahuila",
  "Michoacán de Ocampo": "Michoacán",
  "Veracruz de Ignacio de la Llave": "Veracruz",
  "San Luis Potosí": "SLP",
  "Baja California": "BC",
  "Baja California Sur": "BCS",
  "Quintana Roo": "Q. Roo",
  "Nuevo León": "NL",
  México: "Edo. Méx.",
};

export const STATE_REGIONS = [
  {
    id: "norte",
    label: "Norte",
    states: [
      "Baja California",
      "Baja California Sur",
      "Sonora",
      "Chihuahua",
      "Coahuila de Zaragoza",
      "Nuevo León",
      "Tamaulipas",
      "Durango",
      "Sinaloa",
      "Zacatecas",
    ],
  },
  {
    id: "bajio",
    label: "Bajío y Occidente",
    states: [
      "Aguascalientes",
      "Guanajuato",
      "Querétaro",
      "San Luis Potosí",
      "Nayarit",
      "Jalisco",
      "Colima",
      "Michoacán de Ocampo",
    ],
  },
  {
    id: "centro",
    label: "Centro",
    states: ["Ciudad de México", "México", "Hidalgo", "Morelos", "Puebla", "Tlaxcala"],
  },
  {
    id: "sur",
    label: "Sur y Sureste",
    states: [
      "Guerrero",
      "Oaxaca",
      "Chiapas",
      "Veracruz de Ignacio de la Llave",
      "Tabasco",
      "Campeche",
      "Yucatán",
      "Quintana Roo",
    ],
  },
];

export function shortState(name) {
  return STATE_SHORT[name] || name;
}

export const ESTADO_OPTIONS = ESTADOS_MEXICO.map((estado) => ({
  value: estado,
  label: estado,
}));
